/**
 * Centralized runtime configuration for API/WS endpoints.
 *
 * Значения приходят через readEnv: runtime (/env.js в контейнере) или сборочные REACT_APP_*.
 * Defaults are set to the current dev backend.
 */
import { readEnv } from '../config/env';

const DEFAULT_API_BASE_URL = 'https://dev.api.infiano.app';

export const API_BASE_URL: string = readEnv('REACT_APP_API_BASE_URL') || DEFAULT_API_BASE_URL;

/**
 * Optional overrides for services that may be deployed as separate backends.
 * If not set, we assume they are reachable behind API_BASE_URL under their path prefix.
 */
export const CONNECTOR_BASE_URL: string = readEnv('REACT_APP_CONNECTOR_BASE_URL') || API_BASE_URL;

export const VUSER_BASE_URL: string = readEnv('REACT_APP_VUSER_BASE_URL') || API_BASE_URL;

function deriveWsUrlFromApiBaseUrl(apiBaseUrl: string): string {
  try {
    const url = new URL(apiBaseUrl);
    url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
    url.pathname = '/auto-tune/optimize/ws/stream';
    url.search = '';
    url.hash = '';
    return url.toString();
  } catch {
    return 'wss://dev.api.infiano.app/auto-tune/optimize/ws/stream';
  }
}

export const WS_URL: string = readEnv('REACT_APP_WS_URL') || deriveWsUrlFromApiBaseUrl(API_BASE_URL);
